var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-mobile"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    clipPath: "url(#clip-mobile)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15829",
    "data-name": "Group 15829",
    transform: "translate(4609.221 16226.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_27077",
    "data-name": "Rectangle 27077",
    transform: "translate(-4578.22 -16223) rotate(90)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 22,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 31,
    height: 20,
    rx: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27078",
    "data-name": "Rectangle 27078",
    width: 3,
    height: 10,
    rx: 1.5,
    transform: "translate(-4584.22 -16215) rotate(90)",
    fill: "#5c6d7e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.3accacfc06b8d54e0fabbf7332d04f66.svg";
export { ForwardRef as ReactComponent };